import React, { useState, useEffect } from 'react';
import { postAPI } from '../../../app/api';
import { setStore, removeStore, store } from '../../../app/store';
import Header from '../../Universal/Header';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import Swal from 'sweetalert2';
import 'swiper/css';
import 'swiper/css/navigation';
import Footer from '../../Universal/Footer';
import OurMember from './OurMember';
import SearchAlumniDirectory from './SearchAlumniDirectory';

const { REACT_APP_BRANDURL } = process.env;

// Add CSS for skeleton loader animation
const skeletonStyles = `
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
`;

if (typeof document !== 'undefined') {
    const style = document.createElement('style');
    style.textContent = skeletonStyles;
    document.head.appendChild(style);
}

export default function Alumni() {
    const [HeroData, setHeroData] = useState(null);
    const [HeroLoading, setHeroLoading] = useState(true);

    // Fallback hero data for 'alumni' route
    const fallbackHeroData = {
        title: 'Our Alumni',
        description: 'Our alumni represent the rich legacy and proud heritage of B E College. Spread across diverse fields and industries, they continue to excel as leaders, innovators, and contributors to society. The Ex-Students\' Club serves as a bridge that keeps this vast network connected, celebrating their achievements and strengthening lifelong bonds.',
        image: `${REACT_APP_BRANDURL}theme/assets/images/home/member-banner.jpg`,
        route: 'alumni'
    };

    // Fetch hero data for 'alumni' route
    useEffect(() => {
        fetchHeroData();
    }, []);

    const fetchHeroData = async () => {
        try {
            setHeroLoading(true);
            const response = await postAPI('hero-data/fetchData/alumni', {});

            console.log('Hero API Response:', response);

            if (response?.status === 1 && response?.data) {
                console.log('Hero data fetched:', response.data);
                setHeroData(response.data);
            } else {
                console.warn('Failed to fetch hero data, using fallback');
                setHeroData(fallbackHeroData);
            }
        } catch (error) {
            console.error('Error fetching hero data:', error);
            setHeroData(fallbackHeroData);
        } finally {
            setHeroLoading(false);
        }
    }

    return (
        <>
            <Header />
            <section className="hero-section">
                <div className="banner-image">
                    {HeroLoading ? (
                        <div style={{
                            height: '500px',
                            backgroundColor: '#e0e0e0',
                            animation: 'pulse 1.5s infinite',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <span style={{ color: '#999' }}>Loading...</span>
                        </div>
                    ) : (
                        <img
                            src={HeroData?.backgroundImage ? (HeroData.backgroundImage.startsWith('http') ? HeroData.backgroundImage : `${process.env.REACT_APP_APIBRANDURL || 'https://beapi.becex.org/'}${HeroData.backgroundImage.startsWith('/') ? HeroData.backgroundImage.slice(1) : HeroData.backgroundImage}`) : fallbackHeroData.image}
                            className="img-fluid"
                            alt="banner"
                            onError={(e) => { e.target.src = fallbackHeroData.image; }}
                        />
                    )}
                </div>
                <div className="hero-content">
                    {HeroLoading ? (
                        <>
                            <div className="skeleton-loader" style={{ height: '60px', backgroundColor: '#e0e0e0', marginBottom: '20px', animation: 'pulse 1.5s infinite', borderRadius: '4px' }} />
                            <div className="skeleton-loader" style={{ height: '80px', backgroundColor: '#e0e0e0', animation: 'pulse 1.5s infinite', borderRadius: '4px' }} />
                        </>
                    ) : (
                        <>
                            <h1
                                className="fw-bold display-5"
                            >
                                {HeroData?.title || fallbackHeroData.title}
                            </h1>
                            <p
                                className="mt-lg-3 mt-1 mb-0"
                                style={{
                                    color: HeroData?.descriptionColor || '#ffffff',
                                    fontFamily: HeroData?.descriptionFont || 'Arial'
                                }}
                            >
                                {HeroData?.description || fallbackHeroData.description}
                            </p>
                        </>
                    )}
                </div>
            </section>
            <SearchAlumniDirectory />
            <OurMember />
            <Footer />
        </>
    )
}
